document.addEventListener('DOMContentLoaded', function() {
  const initMundoSilbon = () => {
    const sections = document.querySelectorAll('.mundo-silbon');

    sections.forEach(section => {
      const slider = section.querySelector('.swiper');
      const cardsWrapper = section.querySelector('.mundo-silbon__slider');

      if (!slider) return;

      let swiperInstance = null;
      let observer = null;

      const initOrDestroySwiper = () => {
        if (window.innerWidth < 768) {
          if (!swiperInstance && typeof Swiper !== 'undefined') {
            const scrollY = window.scrollY;
            swiperInstance = new Swiper(slider, {
              slidesPerView: 'auto',
              centeredSlides: false,
              loop: true,
              spaceBetween: 0,
              speed: 600,
            });
            if (window.scrollY !== scrollY) window.scrollTo(0, scrollY);

            let dummySlide = null;
            const sliderWrapper = section.querySelector('.mundo-silbon__slider-wrapper');

            const createDummy = (target) => {
              if (dummySlide) dummySlide.remove();
              dummySlide = document.createElement('div');
              dummySlide.className = target.className + ' dummy-active-slide';
              dummySlide.classList.remove('swiper-slide', 'swiper-slide-active', 'swiper-slide-visible', 'swiper-slide-next', 'swiper-slide-prev');
              dummySlide.innerHTML = target.innerHTML;
              sliderWrapper.appendChild(dummySlide);
              dummySlide.classList.add('blick-active-slide');
              void dummySlide.offsetWidth;
              setTimeout(() => { if (dummySlide) dummySlide.classList.remove('blick-active-slide'); }, 450);
            };

            observer = new MutationObserver((mutations) => {
              mutations.forEach((mutation) => {
                const target = mutation.target;
                if (target.classList && target.classList.contains('swiper-slide')) {
                  const hadActive = mutation.oldValue && mutation.oldValue.includes('swiper-slide-active');
                  const hasActive = target.classList.contains('swiper-slide-active');
                  if (!hadActive && hasActive) createDummy(target);
                }
              });
            });
            observer.observe(slider, { attributes: true, attributeFilter: ['class'], attributeOldValue: true, subtree: true });

            const initialActive = slider.querySelector('.swiper-slide-active');
            if (initialActive) createDummy(initialActive);
          }
        } else {
          if (swiperInstance) {
            swiperInstance.destroy(true, true);
            swiperInstance = null;
          }
          if (observer) {
            observer.disconnect();
            observer = null;
          }
        }
      };

      initOrDestroySwiper();
      window.addEventListener('resize', initOrDestroySwiper);

      if (cardsWrapper) {
        let hoverHistory = [0];
        let reverseInterval = null;
        let mouseleaveTimeout = null;

        const desktopCards = Array.from(section.querySelectorAll('.mundo-silbon__card:not(.swiper-slide-duplicate)'));
        desktopCards.forEach((card) => {
          card.addEventListener('mouseenter', () => {
            if (window.innerWidth < 768) return;
            const allCards = Array.from(section.querySelectorAll('.mundo-silbon__card:not(.swiper-slide-duplicate)'));
            const idx = allCards.indexOf(card);
            if (idx === -1) return;
            if (reverseInterval) { clearInterval(reverseInterval); reverseInterval = null; }
            if (mouseleaveTimeout) { clearTimeout(mouseleaveTimeout); mouseleaveTimeout = null; }
            if (hoverHistory[hoverHistory.length - 1] !== idx) {
              hoverHistory.push(idx);
              if (hoverHistory.length > 50) hoverHistory.shift();
            }
            allCards.forEach(c => c.classList.remove('is-active'));
            card.classList.add('is-active');
          });
        });

        section.addEventListener('mouseleave', () => {
          if (window.innerWidth < 768) return;
          if (reverseInterval) { clearInterval(reverseInterval); reverseInterval = null; }
          if (mouseleaveTimeout) { clearTimeout(mouseleaveTimeout); mouseleaveTimeout = null; }
          mouseleaveTimeout = setTimeout(() => {
            mouseleaveTimeout = null;
            const originalCards = Array.from(section.querySelectorAll('.mundo-silbon__card:not(.swiper-slide-duplicate)'));
            reverseInterval = setInterval(() => {
              hoverHistory.pop();
              if (hoverHistory.length > 0) {
                const prevIndex = hoverHistory[hoverHistory.length - 1];
                originalCards.forEach(c => c.classList.remove('is-active'));
                if (originalCards[prevIndex]) originalCards[prevIndex].classList.add('is-active');
              } else {
                clearInterval(reverseInterval);
                reverseInterval = null;
                originalCards.forEach(c => c.classList.remove('is-active'));
                if (originalCards.length > 0) originalCards[0].classList.add('is-active');
                hoverHistory = [0];
              }
            }, 40);
          }, 300);
        });

        cardsWrapper.addEventListener('click', (e) => {
          const link = e.target.closest('.mundo-silbon__card-link');
          if (link) {
            const card = link.closest('.mundo-silbon__card');
            if (card) {
              if (window.innerWidth >= 768) {
                if (!card.classList.contains('is-active')) e.preventDefault();
              } else {
                if (!card.classList.contains('swiper-slide-active') && !card.classList.contains('swiper-slide-duplicate-active')) e.preventDefault();
              }
            }
          }
        });
      }
    });
  };

  initMundoSilbon();
  document.addEventListener('shopify:section:load', initMundoSilbon);
});
